export {
  get, post, put, delete_,
};

const XSRF_TOKEN_NAME = "csrf_global";

async function get(url, acceptMIMEType, timeout, authRedirectUrl) {
  if (authRedirectUrl) {
    return handleRedirect(rejectOnError(getFetch(url, acceptMIMEType, timeout)), authRedirectUrl);
  }
  return rejectOnError(getFetch(url, acceptMIMEType, timeout));
}

async function post(url, payload, timeout, authRedirectUrl) {
  if (authRedirectUrl) {
    return handleRedirect(rejectOnError(postFetch(url, payload, timeout)), authRedirectUrl);
  }
  return rejectOnError(postFetch(url, payload, timeout));
}

async function put(url, payload, timeout, authRedirectUrl) {
  if (authRedirectUrl) {
    return handleRedirect(rejectOnError(putFetch(url, payload, timeout)), authRedirectUrl);
  }
  return rejectOnError(putFetch(url, payload, timeout));
}

// eslint-disable-next-line no-underscore-dangle
async function delete_(url, payload, timeout, authRedirectUrl) {
  if (authRedirectUrl) {
    return handleRedirect(rejectOnError(deleteFetch(url, payload, timeout)), authRedirectUrl);
  }
  return rejectOnError(deleteFetch(url, payload, timeout));
}

async function getFetch(url, acceptMIMEType, timeout) {
  const paramGet = {
    credentials: "include",
    method: "GET",
    signal: getSignal(timeout),
    mode: "no-cors",
    headers: { Accept: acceptMIMEType },
  };

  return fetch(url, paramGet);
}

async function postFetch(url, payload, timeout) {
  const xsrfToken = getCookieByName(XSRF_TOKEN_NAME);
  const xsrfHeaderKey = `X-${XSRF_TOKEN_NAME}`;

  const paramPost = {
    credentials: "same-origin",
    method: "POST",
    signal: getSignal(timeout),
    headers: {
      "Content-Type": "application/json",
      [xsrfHeaderKey]: xsrfToken,
      "X-Requested-With": "XMLHttpRequest",
    },
    body: JSON.stringify(payload),
  };

  return fetch(url, paramPost);
}

async function putFetch(url, payload, timeout) {
  const xsrfToken = getCookieByName(XSRF_TOKEN_NAME);
  const xsrfHeaderKey = `X-${XSRF_TOKEN_NAME}`;

  const paramPost = {
    credentials: "same-origin",
    method: "PUT",
    signal: getSignal(timeout),
    headers: {
      "Content-Type": "application/json",
      [xsrfHeaderKey]: xsrfToken,
      "X-Requested-With": "XMLHttpRequest",
    },
    body: JSON.stringify(payload),
  };

  return fetch(url, paramPost);
}

async function deleteFetch(url, payload, timeout) {
  const xsrfToken = getCookieByName(XSRF_TOKEN_NAME);
  const xsrfHeaderKey = `X-${XSRF_TOKEN_NAME}`;

  const paramDelete = {
    credentials: "same-origin",
    method: "DELETE",
    signal: getSignal(timeout),
    headers: {
      "Content-Type": "application/json",
      [xsrfHeaderKey]: xsrfToken,
      "X-Requested-With": "XMLHttpRequest",
    },
    body: JSON.stringify(payload),
  };

  return fetch(url, paramDelete);
}

async function rejectOnError(response) {
  const res = await response;
  if (!res.ok) {
    return Promise.reject(res);
  }

  return response;
}

function handleRedirect(response, authRedirectUrl) {
  return response.catch((e) => {
    if (e instanceof Response && (e.status === 401 || e.status === 403)) {
      window.location.assign(authRedirectUrl);
    }
    return Promise.reject(e);
  });
}

function getSignal(timeout) {
  let timeoutSignal;
  if (timeout) {
    const timeoutAbortController = new AbortController();
    setTimeout(() => timeoutAbortController.abort(), timeout);
    timeoutSignal = timeoutAbortController.signal;
  }
  return timeoutSignal;
}

function getCookieByName(name) {
  const match = document.cookie.match(new RegExp(`${name}=([^;]+)`));
  if (match) {
    return match[1];
  }
  return "";
}
